import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";
import {gsap} from "gsap";
import {IFeatureInfo, X_WAYS_ANIMATIONS} from "../server/IKMDData";
import {KMDSymbol} from "../reels/KMDSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {KMDSound} from "../sound/KMDSound";

export class KMDMainReelsXWaysExpandRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (KennethMustDie.model.xWaysMainReels.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            xWaysData: IFeatureInfo[] = KennethMustDie.model.xWaysMainReels,
            yPosMainReels: number[][] = [[0, 112.5, 37.5], [-37.5, 0, 37.5], [-37.5, -112.5, 0]],
            animNamesMainReels: string[] = [X_WAYS_ANIMATIONS.EXPAND_DOWN, X_WAYS_ANIMATIONS.EXPAND_MID, X_WAYS_ANIMATIONS.EXPAND_UP];

        tl.add(() => {
            KennethMustDie.reelView.toggleMask(false);
            KennethMustDie.specialReelView.toggleMask(false);

            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });

            // #240
            KennethMustDie.soundPlayer.playSound(KMDSound.X_WAYS_GROW);
        }, 0);

        xWaysData.forEach((xWay: IFeatureInfo) => {
            const allSymbols: SimpleReelModelSymbolData[] = KennethMustDie.reelView.reelModels[xWay.originReelId].stopSymbols;

            allSymbols.forEach((value: SimpleReelModelSymbolData, symId: number) => {
                let sym: KMDSymbol = (value.positionable as KMDSymbol);
                const yPos: number[] = yPosMainReels[xWay.originSymId];

                if (value.reelPosition === xWay.originSymId) {
                    tl.add([
                        sym.setState(animNamesMainReels[xWay.originSymId]),
                        sym.translateY(yPos[value.reelPosition], true),
                        () => {
                            sym.hideSymbolCount();

                            // send it to top of the layer
                            sym.parent.addChild(sym);
                        }
                    ], 0).timeScale(0.75); // #528 -> pt 3
                } else {
                    tl.add(() => {
                        const multi: number = KennethMustDie.model.gameData.multiplier[xWay.originReelId][symId];

                        sym.resizeAsPerXWays(2, multi);
                        sym.displayLines(multi);
                        sym.translateY(yPos[value.reelPosition], false);
                    }, 0.3333);
                }
            });
        });

        tl.to(this, {
            duration: 0.1
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}